export const XML_SCHEME = '2.0'
export const XML_PARSER_ERROR = 'Invalid XML format.'
export const DEFAULT_PROJECT_TITLE = 'Untitled project'
export const MAIN_SECTION_TITLE = 'Main section'
export const DEFAULT_SECTION_TITLE = 'Section'
